export const groupsButtonId = "groups-button";
export const generateInviteButtonId = "generate-invite-button";

export const charactersButtonId = "characters-button";

export const shipsButtonId = "ships-button";

export const gameMasterButtonId = "gm-button";

export const compendiumButtonId = "compendium-button";
export const compendiumSearchId = "compendium-search";

export const editLayoutButtonId = "edit-layout-button";
export const settingsButtonId = "settings-button";

export const addItemButtonId = "add-item-button";
export const getPageAddItemButtonId = (page) => `${page}-add-item-button`;
export const selectItemDropdownId = "select-item-dropdown";

export const diceRollerButtonId = "dice-roller-button";
export const compendiumModalButtonId = "compendium-modal-button";
export const ChatButtonId = "chat-button";

//edit layout
export const editLayoutModalButtons = "edit-layout-buttons";
export const editLayoutModalCurrentLayout = "edit-layout-current";
export const editLayoutModalDragTip = "edit-layout-drag-tip";
export const editLayoutModalSubmit = "edit-layout-submit";

// character
export const resizableAspectResizerId = "resizable-aspect-resizer";
